<template>
	<nav class="nav">
		<ul class="nav__list">
			<li
				v-for="({ title, link, disabled, hidden }, i) in navItems"
				:key="i"
				class="nav__item"
				:class="{ disabled: disabled, hidden: hidden }">
				<NuxtLinkLocale :to="`/${link}`" @click="menuStore.isOpen = false">
					{{ title }}
				</NuxtLinkLocale>
			</li>
		</ul>
	</nav>
</template>

<script setup lang="ts">
	const { t } = useI18n()
	const navItems = computed(() => [
		{ title: t('menu.about'), link: '#about-us' },
		// { title: t('menu.services'), link: '#advantages' },
		{ title: t('menu.ecosystem'), link: '#ecosystem' },
		{ title: t('menu.mediakit'), link: '#mediakit' },
		{ title: t('menu.partners'), link: '#partners' },
		{ title: t('menu.publishers'), link: 'publishers' },
		{ title: t('menu.pricing'), link: '#prices', disabled: true, hidden: true },
		{ title: t('menu.contacts'), link: '#footerAnchor' },
	])

	const menuStore = useMenuStore()

	const availableAnchors = ref<string[]>([])

	onMounted(() => {
		availableAnchors.value = navItems.value
			.map((item: { link: string }) => item.link)
			.filter((link: string) => {
				if (!link?.startsWith('#')) return false
				const id = link.slice(1)
				return !!document.getElementById(id)
			}) as string[]
	})

	// function isAnchorAvailable(link?: string): boolean {
	// 	if (!link) return false
	// 	return availableAnchors.value.includes(link)
	// }
</script>

<style scoped lang="scss">
	.nav {
		margin-left: auto;
		color: var(--white);

		@media (width <= 991.98px) {
			order: 1;
			width: 100%;
			padding: 16px;
			margin-left: unset;
			text-align: right;

			// opacity: 0;
		}

		// @media (width <= 991.98px) {
		// 	position: fixed;
		// 	top: 73px;
		// 	left: 0;
		// 	background-color: #00000040;
		// 	backdrop-filter: blur(0.5rem);
		// 	width: 100%;
		// 	padding: 16px;
		// 	z-index: 10;
		// }
		&__list {
			display: flex;
			gap: 20px;
			font-weight: 600;
			&:hover {
				.nav__item {
					opacity: 0.5;
					&:hover {
						opacity: 1;
					}
				}
			}

			@media (width <= 991.98px) {
				flex-direction: column;
			}
		}
		&__item {
			transition: 0.4s opacity;

			@media (width <= 991.98px) {
				opacity: 1;
			}
		}
	}
</style>
